module.exports = __webpack_public_path__ + "img/24_34.309d8bc5.png";